'use client';

import {
  YouMightLikeWaterFall,
  type YouMightLikeTrackingHandlers,
} from '@/app/cart/components/YouMightLikeWaterFall';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import { useContext } from 'react';

interface ErrorPageRecommendationsProps {
  onItemClick?: () => void;
}

const ERROR_PAGE_TRACKING = {
  collectScene: '异常页面猜你喜欢推荐商品',
  onItemClick: () => undefined,
  onProductInView: () => undefined,
  onProductValidExposure: () => undefined,
  onModelExp: () => undefined,
} satisfies YouMightLikeTrackingHandlers;

/** 错误页复用购物车推荐样式和商品卡片，但请求不携带 scene。 */
export default function ErrorPageRecommendations({ onItemClick }: ErrorPageRecommendationsProps) {
  const { deviceType } = useContext(ResponsiveContext);
  const currencyReady = useStore((state) => state.currencyReady);

  if (!currencyReady) return null;

  return (
    <YouMightLikeWaterFall
      deviceType={deviceType}
      frameWidth="100%"
      recommendList={[]}
      recommendationStrategy="error-page"
      tracking={ERROR_PAGE_TRACKING}
      onItemClick={onItemClick}
    />
  );
}
